/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DataChartPieA2Icon16Light } from './DataChartPieA2Icon16Light';
import { DataChartPieA2Icon16Regular } from './DataChartPieA2Icon16Regular';
import { DataChartPieA2Icon16Solid } from './DataChartPieA2Icon16Solid';
import { DataChartPieA2Icon20Light } from './DataChartPieA2Icon20Light';
import { DataChartPieA2Icon20Regular } from './DataChartPieA2Icon20Regular';
import { DataChartPieA2Icon20Solid } from './DataChartPieA2Icon20Solid';
import { DataChartPieA2Icon24Regular } from './DataChartPieA2Icon24Regular';
import { DataChartPieA2Icon24Solid } from './DataChartPieA2Icon24Solid';
import { DataChartPieA2Icon32Regular } from './DataChartPieA2Icon32Regular';
import { DataChartPieA2Icon64Regular } from './DataChartPieA2Icon64Regular';
var sizes = {
    16: {
        light: DataChartPieA2Icon16Light,
        regular: DataChartPieA2Icon16Regular,
        solid: DataChartPieA2Icon16Solid,
    },
    20: {
        light: DataChartPieA2Icon20Light,
        regular: DataChartPieA2Icon20Regular,
        solid: DataChartPieA2Icon20Solid,
    },
    24: {
        regular: DataChartPieA2Icon24Regular,
        solid: DataChartPieA2Icon24Solid,
    },
    32: {
        regular: DataChartPieA2Icon32Regular,
    },
    64: {
        regular: DataChartPieA2Icon64Regular,
    },
};
export var DataChartPieA2Icon = forwardRef('DataChartPieA2Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
